import { ROLE_NAMES, type SessionRole } from '@jaf/contracts';

/** Perfil do usuário com as empresas em que vale (`null` = todas). */
export interface RoleAssignment {
  roleName: string;
  companyIds: string[] | null;
}

/** Agrupa os vínculos da sessão por perfil, na ordem em que aparecem. */
export function roleAssignments(roles: readonly SessionRole[]): RoleAssignment[] {
  const byCode = new Map<SessionRole['code'], string[] | null>();
  for (const role of roles) {
    const current = byCode.get(role.code);
    if (role.companyId === null || current === null) byCode.set(role.code, null);
    else byCode.set(role.code, [...(current ?? []), role.companyId]);
  }
  return [...byCode].map(([code, companyIds]) => ({ roleName: ROLE_NAMES[code], companyIds }));
}
